export const TAG_PAGE_VIDEO_LIMIT = 12;
export const INVALID_TAG_CHAR_REGEX = /(\s+|\W|_)/giu;
